module.exports = __webpack_public_path__ + "static/media/gypsum and drywall.489e35d2.png";